import { calcTwelvePerspectiveMetrics } from './twelvePerspective';

/**
 * Backfill fields missing from older saved calc results so the UI can render
 * without re-running the full model.
 */
export function hydrateCalcResult(calcResult) {
  if (!calcResult) {
    return calcResult;
  }

  const needsCashExposure = calcResult.cashExposurePct == null;
  const needsRunoffPlusCashExposure =
    calcResult.runoffPlusCashExposurePct == null;

  if (!needsCashExposure && !needsRunoffPlusCashExposure) {
    return calcResult;
  }

  // Very old saved results may be missing the core series the backfill derives
  // from. Without these we can't recompute the exposure metrics, so leave the
  // result untouched (the results table already renders missing rows as empty)
  // rather than throwing while loading the model.
  const hasCoreSeries =
    Array.isArray(calcResult.revenue) &&
    Array.isArray(calcResult.endBal) &&
    Array.isArray(calcResult.cashEnd) &&
    Array.isArray(calcResult.cohortRevenue);
  if (!hasCoreSeries) {
    return calcResult;
  }

  const metrics = calcTwelvePerspectiveMetrics({
    revenue: calcResult.revenue,
    endBal: calcResult.endBal,
    cashEnd: calcResult.cashEnd,
    cohortRevenue: calcResult.cohortRevenue,
    oldCohortRevenueRows: calcResult.oldCohortRevenueRows,
    N_OUT: calcResult.N_OUT,
  });

  return {
    ...calcResult,
    ...(needsCashExposure
      ? { cashExposurePct: metrics.cashExposurePct }
      : {}),
    ...(needsRunoffPlusCashExposure
      ? { runoffPlusCashExposurePct: metrics.runoffPlusCashExposurePct }
      : {}),
  };
}
